import { create } from 'zustand'

export type ModuleDraft = {
  moduleId: string
  objectName: string | null
  code: string
  dirty: boolean
}

interface ModuleDraftState {
  drafts: Record<string, ModuleDraft>
}

export const useModuleDraftStore = create<ModuleDraftState>(() => ({
  drafts: {},
}))

export function setModuleDraft(input: {
  moduleId: string
  code: string
  objectName?: string | null
  dirty?: boolean
}): void {
  const { moduleId, code, objectName, dirty = true } = input
  useModuleDraftStore.setState((state) => ({
    drafts: {
      ...state.drafts,
      [moduleId]: {
        moduleId,
        objectName: objectName ?? state.drafts[moduleId]?.objectName ?? null,
        code,
        dirty,
      },
    },
  }))
}

export function getModuleDraft(moduleId: string): ModuleDraft | undefined {
  return useModuleDraftStore.getState().drafts[moduleId]
}

export function markModuleDraftClean(moduleId: string, code?: string): void {
  useModuleDraftStore.setState((state) => {
    const existing = state.drafts[moduleId]
    if (!existing) return state
    return {
      drafts: {
        ...state.drafts,
        [moduleId]: {
          ...existing,
          code: code ?? existing.code,
          dirty: false,
        },
      },
    }
  })
}

export function clearModuleDraft(moduleId: string): void {
  useModuleDraftStore.setState((state) => {
    if (!(moduleId in state.drafts)) return state
    const { [moduleId]: _removed, ...drafts } = state.drafts
    return { drafts }
  })
}

export function listDirtyModuleDrafts(): ModuleDraft[] {
  return Object.values(useModuleDraftStore.getState().drafts).filter(
    (d) => d.dirty
  )
}
